<template>
  <footer>
    <div class="container">
      <div class="row row-20" style="width: 100%;">
        <img src="@/assets/footer_logo.svg" class="mb-sm-1" width="160" />
        <div class="contents">
          <h3>レッスンコンテンツ一覧</h3>
          <h4>子音編</h4>
          <ul>
            <li v-for="lesson in lessons" v-if="lesson.category === 'consonant'">
              <router-link
                class="phoneme"
                :to="{ path: 'lesson',  query: { category: lesson.titlePhoneme }}"
                :style="lesson.titlePhoneme === '(h)w' ? `font-size: 0.78rem` : `font-size: 1.1rem`"
              >{{lesson.targetPhoneme}}</router-link>
            </li>
          </ul>
          <h4>母音</h4>
          <ul>
            <li v-for="lesson in lessons" v-if="lesson.category === 'vowel'">
              <router-link
                class="phoneme"
                style="font-size: 1.1rem"
                :to="{ path: 'lesson',  query: { category: lesson.titlePhoneme }}"
              >{{lesson.titlePhoneme}}</router-link>
            </li>
          </ul>
          <h4>エクササイズ</h4>
        </div>
      </div>
      <div class>
        <h3>「ネイティブの口」サポートセンター</h3>
        <p>合同会社プロンエイド</p>
        <p>〒151-0066</p>
        <p>東京都渋谷区西原3-2-2 クボタビル4F</p>
        <a href="https://nativenokuchi.com/contact/" style="display: inline-block" target="_blank">
          <p>お問い合わせフォーム</p>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
const lessons = require("@/resources/lessons");

export default {
  data() {
    return {
      dialogVisible: false,
      lessons: []
    };
  },
  methods: {},
  mounted() {
    this.lessons = lessons;
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 30px;
  background-color: #555;
  padding: 30px 100px;
}

.contents {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  margin: 24px 0;
  padding: 12px 0;
}
footer {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);

  img {
    margin-top: 20px;
  }

  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    margin: 1rem 0;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: start-end;
    flex-wrap: wrap;
  }

  li {
    margin-bottom: 6px;
  }

  p {
    margin: 0;
    padding-top: 10px;
  }
}

.phoneme {
  height: 35px !important;
  width: 35px !important;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 50%; /* may require vendor prefixes */
  background: white;
  color: #555 !important;
  &:hover {
    background-color: $main-color;
    color: white !important;
    transform: scale(1.1);
  }
}

a {
  color: #fff !important;
  opacity: 0.9;
}
</style>
